<template>
    <div class="module">
        <div class="content">
            <IfmSubHeader title="等级认证"/>
            <div class="table">
                <div class="row">
                    <div class="card">EIFM 初级国际财务管理师</div>
                    <div class="line"/>
                    <div class="card">IFM 中级国际财务管理师</div>
                    <div class="line"/>
                    <div class="card">SIFM 高级国际财务管理师</div>
                </div>
                <div class="row1">学习课程</div>
                <div class="row row2">
                    <div class="content2">
                        <div v-for="(item,index) in arr1" :key="index" class="single">
                            <div class="dot"/>
                            <div class="news-content">
                                {{item}}
                            </div>
                        </div>
                    </div>
                    <div class="line"/>
                    <div class="content2">
                        <div v-for="(item,index) in arr3" :key="index" class="single">
                            <div class="dot"/>
                            <div class="news-content">
                                {{item}}
                            </div>
                        </div>
                    </div>
                    <div class="line"/>
                    <div class="content2">
                        <div v-for="(item,index) in arr4" :key="index" class="single">
                            <div class="dot"/>
                            <div class="news-content">
                                {{item}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row3">适合人群</div>
                <div class="row row4">
                    <div class="content4">
                        学习了基础会计及财务管理初级知识,准备在报表、报税、管理会计、税法等方面进一步提升的学生。
                    </div>
                    <div class="line"/>
                    <div class="content4">
                        学习了会计、财务管理、经济法相关等知识,准备在管理会计、组织与管理理论、金融、投资、全面预算管理、企业并购与重组、风险管理、资产管理等方面进一步提升的学生。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            arr1:['财务管理职业道德','财务分析工具','全面预算管理'],
            arr2:['财务管理职业道德','财务分析工具','全面预算管理','内部控制与风险管理'],
            arr3:['财务管理职业道德','公司治理','金融工具','财务分析工具','公司战略与财务','企业并购与重组','风险管理','全面预算管理'],
            arr4:['财务管理职业道德','公司治理','金融工具','财务分析工具','公司战略与财务','企业并购与重组','风险管理','全面预算管理','Corporate Financing（英文）'],
        }
    },
}
</script>
<style lang="scss" scoped>
.module{
    background: #fff;
    padding: 25px 0 39px 0;
    .content{
        width: 1120px;
        margin: auto;
    }
}
.table{
    width: 100%;
    margin-top: 25px;
    .row{
        width: 100%;
        display: flex;
        
    }
    div{
        box-sizing: border-box;
    }
    .row1,.row3{
        width: 100%;
        height: 51px;
        line-height: 51px;
        font-size: 18px;
        color: #333333;
        letter-spacing: 0.51px;
        font-weight: 500;
        text-align: center;
        background: #F0F0F0;
        border-left: 1px solid #E2E2E2;
        border-right: 1px solid #E2E2E2;
    }
    .row2,.row4{
        border-left: 1px solid #E2E2E2;
        border-right: 1px solid #E2E2E2;
        border-top: 2px solid #E2E2E2;
        border-bottom: 2px solid #E2E2E2;
        background: #F9F9F9;
        .content2{
            flex: 1;
            padding-top: 20px;
            padding-bottom: 20px;
            .single{
                font-size: 14px;
                color: #333333;
                padding-left: 30px;
                margin-bottom: 7px;
                .dot{
                    width: 4px;
                    height: 4px;
                    display: inline-block;
                    background: #333333;
                    vertical-align: middle;
                    border-radius: 50%;
                }
                .news-content{
                    margin-left: 8px;
                    display: inline-block;
                    vertical-align: middle;
                    width: calc(100% - 18px);
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    word-break: break-all;
                }
            }
        }
        .line{
            width:2px;
            height: auto;
            background: #E2E2E2;
        }
        .content4{
            flex: 1;
            padding: 20px;
        }
    }

    
}
.card{
    flex: 1;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0.51px;
    font-weight: 600;
    text-align: center;
}
.card:nth-child(1){
    background: #35BFCD;
}
.card:nth-child(3){
    background: #2060A4;
}
.card:nth-child(5){
    background: #A42072;
}
.line{
    width: 1px;
    height: 60px;
    background: #fff;
}

</style>
